const i18n = {
  'stockRequisition': {
    'tab': {
      'pending': '等候中',
      'done': '已完成',
      'void': '已作廢',
    },
    'name': '領用單',
    'table': {
      'pending': {
        'title': '領用單列表 - 待簽核',
      },
      'title': '領用單列表',
      'selected': '已選擇 {count} 筆領用單',
      'header': {
        'sn': '領用單號',
        'source': '領用單位',
        'sourceName': '領用單位',
        'createdBy': '領用人',
        'createdAt': '建立日期',
        'date': '領用日期',
      },
      'detail': {
        'sn': '領用單號',
        'source': '領用單位',
        'sourceName': '領用單位',
        'createdBy': '領用人',
        'createdAt': '建立日期',
        'date': '領用日期',
        'note': '備註',
        'merchandise': '商品',
        'merchandiseName': '商品名稱',
        'merchandiseCode': '商品品號',
      },
    },
    'dialog': {
      'title': {
        'add': '新增領用單',
        'edit': '編輯領用單',
      }
    },
    'merchandise': {
      'code': '品號',
      'name': '品名',
      'unitPrice': '單價',
      'stock': '庫存數量',
      'amount': '領用數量',
      'sku': '單位',
      'price': '金額',
      'note': '備註',
      'statusText': '狀態',
      'unit': '單位',
      'lotNumber': '批號',
      'expectedDate': '效期',
    }
  },
  'editStockRequisition': {
    'table': {
      'title': '領用商品清單',
      'selected': '已選擇 {count} 個項目',
    },
    'selectMerchandise': '選擇商品',
    'addLotNumber': '新增批號',
    'removeMerchandise': '移除商品',
  }
}
export default i18n
